import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useParams,
} from "react-router-dom";

export default function PollingResults() {
  useEffect(() => window.scrollTo(0, 0), []);
  return (
    <div className="row">
      <div className="col-sm-12">
        <h3>Polling Results</h3>
        <ul className="page-breadcrumb breadcrumb">
          <li>
            <a href="#">F.O.R.M.S.</a>
            <i className="fa fa-angle-right"></i>
          </li>
          <li>
            <a href="#">Verification</a>
            <i className="fa fa-angle-right"></i>
          </li>
          <li>
            <a href="#">Polling Results</a>
          </li>
        </ul>
        <div className="text-right">
          <Link className="btn btn-primary" to="/forms/pollingresults/new">
            Poll Households
          </Link>
        </div>
      </div>

      <Switch>
        <Route path="/forms/pollingresults/:action" children={<Results />} />
      </Switch>
    </div>
  );
}

function Results() {
  let { action } = useParams();

  return (
    <div className="col-sm-12">
      <h4>{action == "new" ? "Poll Students" : ""}</h4>
    </div>
  );
}
